/*@ngInject*/
const DeleteCollaborationNoteRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.deleteCollaborationNote = function (noteId) {
        let url = '/rest/Note/' + noteId;

        return this.delete(url);
    };
};

angular.module('gw-um-submission')
    .service('deleteCollaborationNoteRepository', DeleteCollaborationNoteRepository);
